import instance from './AxiosService';

const DropService = {
  getAllDrops: async () => {
    return await instance.get('/drop/all-drops');
  },
  getMyDrops: async () => {
    return await instance.get('/drop/my-drops');
  },
  createDrop: async (dropData) => {
    return await instance.post('/drop/create', dropData);
  },
  getDropAnalytics: async (dropId) => {
    return await instance.get(`/drop/analytics/${dropId}`);
  },
  getDropById: async (dropId) => {
    return await instance.get(`/drop/${dropId}`);
  },
  updateDrop: async (dropId, dropData) => {
    return await instance.put(`/drop/${dropId}`, dropData);
  },
  deleteDrop: async (dropId) => {
    return await instance.delete(`/drop/${dropId}`);
  },
};

export default DropService;
